import { SuperDrawerContent, SuperDrawerHeader, TabsWithContent, useSessionStorage } from "@homebound/beam";
import { AdminCostCodeFragment } from "src/routes/admin/costCodes/CostCodes.generated";
import { CostCodeHistoryTab } from "./CostCodeHistoryTab";
import { CostCodeMaterialLeadTimesTab } from "./CostCodeMaterialLeadTimesTab";
import { CostCodeOverviewTab } from "./CostCodeOverviewTab";
import { ItemsDrawer } from "./ItemsDrawer";

type CostCodesSuperDrawerTabsProps = { costCode: AdminCostCodeFragment; isOptionCatalogV2Enabled: boolean };

export function CostCodesSuperDrawerTabs({ costCode, isOptionCatalogV2Enabled }: CostCodesSuperDrawerTabsProps) {
  const { id, name } = costCode;
  const [selectedTab, setSelectedTab] = useSessionStorage("costCodesSuperDrawerTab", "overview");

  const overviewTab = {
    name: "Overview",
    value: "overview",
    render: () => <CostCodeOverviewTab costCodeId={id} isOptionCatalogV2Enabled={isOptionCatalogV2Enabled} />,
  };

  const itemsTab = { name: "Items", value: "items", render: () => <ItemsDrawer id={id} /> };

  const materialLeadTimesTab = {
    name: "Material Lead Times",
    value: "materialLeadTimes",
    render: () => <CostCodeMaterialLeadTimesTab costCodeId={id} />,
  };

  const historyTab = { name: "History", value: "history", render: () => <CostCodeHistoryTab costCodeId={id} /> };

  const tabs = [overviewTab, itemsTab];
  if (isOptionCatalogV2Enabled) tabs.push(materialLeadTimesTab);
  if (isOptionCatalogV2Enabled) tabs.push(historyTab);

  return (
    <>
      <SuperDrawerHeader title={name} />
      <SuperDrawerContent>
        <TabsWithContent tabs={tabs} selected={selectedTab} onChange={setSelectedTab} />
      </SuperDrawerContent>
    </>
  );
}
